import React, { useState } from 'react';
import deleteIcon from '@sg/assests/svg/delete-icon.svg';
import deleteIconHighlight from '@sg/assests/svg/delete-icon-highlight.svg';
import './index.scss';
import { Bubble } from 'tea-component';

interface DeleteButtonProps {
  onClick: (e?: React.MouseEvent) => void;
  className?: string;
  title?: string;
  disabled?: boolean;
  disabledTooltip?: string; // 禁用状态的自定义提示，如果未提供则使用 title
  onMouseDown?: (e: React.MouseEvent) => void; // 允许父组件处理mouseDown事件（用于阻止input失焦）
}

const DeleteButton: React.FC<DeleteButtonProps> = ({
  onClick,
  className = '',
  title = 'Delete',
  disabled = false,
  disabledTooltip,
  onMouseDown
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    if (disabled) return;
    e?.stopPropagation();
    onClick(e);
  };

  const handleMouseDown = (e: React.MouseEvent) => {
    if (disabled) return;
    // 阻止默认行为，防止输入框失去焦点
    e.preventDefault();
    e.stopPropagation();
    if (onMouseDown) {
      onMouseDown(e);
    }
  };

  const imgElement = (
      <img 
      src={isHovered && !disabled ? deleteIconHighlight : deleteIcon} 
        alt={title}
        className={`dbs-delete-button ${className} ${disabled ? 'dbs-delete-button-disabled' : ''}`}
        onClick={handleClick}
        onMouseDown={handleMouseDown}
        onMouseEnter={() => !disabled && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      style={{
        opacity: disabled ? 0.4 : 1,
        filter: disabled ? 'grayscale(100%)' : 'none'
      }}
    />
  );

  // 确定要显示的提示内容
  // 禁用状态：优先使用 disabledTooltip，否则使用 title
  // 非禁用状态：使用 title
  const tooltipContent = disabled && disabledTooltip ? disabledTooltip : title;

  return (
    <Bubble content={tooltipContent} trigger="hover" className="dbs-delete-button-bubble">
      {imgElement}
    </Bubble>
  );
};

export default DeleteButton;
